(() => {
  const clean = value => value.replace(/&quot;/g, '').replace(/["\\]/g, '').trim();
  const precise = value => clean(value).split(/\s+/).filter(Boolean).map(word => '"' + word + '"').join(' ');
  window.emPreciseSearch = precise;
  const searchPath = theme.routes.search_url;
  const current = new URL(window.location.href);
  const term = current.searchParams.get('q');
  if (current.pathname === searchPath && term?.trim() && !current.searchParams.has('em_related') && term !== precise(term)) {
    current.searchParams.set('q', precise(term));
    window.location.replace(current.href);
    return;
  }
  document.querySelectorAll('form.searchform').forEach(form => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    input.value = clean(input.value);
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!input.value.trim()) return;
      const destination = new URL(form.action);
      destination.searchParams.set('q', precise(input.value));
      window.location.assign(destination.href);
    });
  });
  const related = document.querySelector('[data-em-related-search]');
  if (related && term) {
    const destination = new URL(searchPath, window.location.origin);
    destination.searchParams.set('q', clean(term));
    destination.searchParams.set('em_related', '1');
    related.href = destination.href;
    related.hidden = current.searchParams.has('em_related');
  }
})();
